import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="row weatherDetails">
        <div className="col">
          <WeatherTemperature
            celcius={props.data.temperature}
            iconSource={props.data.iconURL}
          />
        </div>
        <div className="col">
          <div className="overview">
            <h1 id="cityName">{props.data.cityName}</h1>
            <ul className="overview-list">
              <li>
                <FormattedDate data={props.data.date} />
              </li>
              <li className="text-capitalize">{props.data.description}</li>
              <li>
                Humidity: <strong>{props.data.humidity}%</strong>, Wind:{" "}
                <strong>{props.data.wind}km/h</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
